module.exports = __webpack_public_path__ + "img/logo.93f94a11.png";